import type { SbBlokData } from "@storyblok/react/rsc";

import type { DocumentCard } from "@/components/optilase/hub/document-cards-view";
import { resolveLink, type StoryblokLink } from "./storyblok-link";
import type { Region } from "./region";

type Asset = { filename?: string; alt?: string };

export type DocumentCardBlok = SbBlokData & {
  title?: string;
  description?: string;
  cover?: Asset;
  file?: StoryblokLink;
  meta?: string;
  button_label?: string;
};

export function toDocumentCards(
  bloks: DocumentCardBlok[] | undefined,
  region: Region,
): DocumentCard[] {
  return (bloks ?? []).map((card) => ({
    id: card._uid as string,
    title: card.title,
    description: card.description,
    meta: card.meta,
    cover: card.cover?.filename
      ? { filename: card.cover.filename, alt: card.cover.alt || "" }
      : null,
    href: resolveLink(card.file, region).href,
    buttonLabel: card.button_label,
  }));
}
